<template>
  <div>
    <b-col class="text-left">
      <router-link :to="{ name: 'Form' }">
        <b-button pill variant="purple" class="ml-1 mb-1"
        >فرم ها
        </b-button
        >
      </router-link>

    </b-col>

    <form @submit.prevent="onSubmit">
      <b-form-row>

        <form-group class="col-lg-6" :validations="$v.form.name">
          <div slot-scope="{ errors, invalid }">
            <label>نام</label>

            <input v-model="form.name" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <div class="col-lg-6">
          <languageBox class="mb-5 " v-model="form.language_id" :validation="$v.form.language_id"/>
        </div>

        <form-group class="col-lg-12" :validations="$v.form.form_questions">
          <div slot-scope="{ errors, invalid }">
            <h5>سوالات</h5>

            <create-form-json :form="form"/>

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </b-form-row>
      <b-col class="text-center">
        <button class="btn rounded-pill w-100 text-center btn-primary px-5">ثبت</button>
      </b-col>
    </form>
  </div>
</template>

<script>
import {numeric, required} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import languageBox from "../Language/LanguageBox.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import CreateFormJson from "./CreateFormJson/CreateFormJson.vue";

export default {
  name: "BaseForm",
  components: {CreateFormJson, languageBox, FormErrorsManager, FormGroup},
  data() {
    return {
      form: {
        name: '',
        language_id: null,
        form_questions: '',
      }
    }
  },
  validations: {
    form: {
      name: {required},
      language_id: {required},
      form_questions: {required},
    },
  },
  computed: {
    updateMode() {
      return this.$route.params.id != undefined
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    async createForm() {
      let req = await this.$store.dispatch('Form/createForm', this.form)
      let itemId = req.data.data.id;
      toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
      await this.$router.push({name: "FormUpdate", params: {id: itemId}})
    },
    async loadForm() {
      let form = {
        form_id: this.$route.params.id
      }
      let req = await this.$store.dispatch('Form/getFormDashboard', form)
      let itemData = req.data.data;
      this.form = itemData
      this.form.form_questions = JSON.parse(this.form.form_questions)
      document.getElementById(`language_item_${itemData.language_id}`).click();
    },
    async updateForm() {
      let req = await this.$store.dispatch('Form/updateForm', this.form)
      let itemId = req.data.data.id;
      toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
    },
    onSubmit() {

      if (!this.invalid()) {
        return false
      }

      if (this.updateMode) { // update mode
        this.updateForm()
      } else { // create mode
        this.createForm()
      }

    }
  },
  mounted() {
    if (this.updateMode) {
      this.loadForm()
    }
  }
}
</script>

<style scoped>

</style>